// @ts-nocheck: converted from JS

import Files from './Files';

export default Files;
